<div class="multi-ticket-wrap">

  <div *ngIf="isLoading" class="multi-ticket-loading text-center py-3">

    <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>

    <p class="mt-2 mb-0 text-muted">Chargement des tickets sélectionnés…</p>

  </div>



  <div class="multi-ticket-filter" *ngIf="!isLoading && rows.length">

    <div class="input-group form-password-toggle d-flex multi-ticket-search">

      <input
        type="text"
        class="form-control"
        placeholder="Rechercher un ticket (numéro, client, entrepôt…)"
        aria-label="Rechercher un ticket"
        [(ngModel)]="searchTerm"
      />

      <div class="input-group-append">

        <span class="input-group-text">

          <svg *ngIf="!searchTerm" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
               viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>

          <svg *ngIf="searchTerm" (click)="clearSearch()" role="button" aria-label="Effacer la recherche"
               xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>

        </span>

      </div>

    </div>

  </div>

  <div class="table-responsive" *ngIf="!isLoading && rows.length">

    <table class="table table-hover multi-ticket-table mb-0">

      <thead>

        <tr>

          <th>Numéro ticket</th>

          <th>Date</th>

          <th>Établissement</th>

          <th>Statut</th>

          <th *ngIf="selectionMode === 'facture'">Client</th>

          <th class="text-end">Total</th>

          <th class="text-center" style="width: 48px;"></th>

        </tr>

      </thead>

      <tbody>

        <tr

          *ngFor="let row of filteredRows; trackBy: trackById"

          [ngClass]="rowClass(row)"

        >

          <td>

            <strong>{{ row.numero }}</strong>

            <div *ngIf="row.error" class="text-danger small">{{ row.error }}</div>

            <div *ngIf="selectionMode === 'cancel' && row.requiresAdmin" class="text-danger small">

              Terminé / payé — réservé à l'administration

            </div>

            <div *ngIf="selectionMode === 'cancel' && row.kind === 'already_cancelled'" class="text-muted small">Déjà annulé</div>

            <div *ngIf="selectionMode === 'facture' && row.kind === 'already_invoiced'" class="text-muted small">Déjà facturé</div>

            <div *ngIf="selectionMode === 'facture' && row.kind === 'not_ready'" class="text-danger small">Ticket non terminé / non payé</div>

            <div *ngIf="selectionMode === 'facture' && row.kind === 'already_cancelled'" class="text-muted small">Ticket annulé</div>
            <div *ngIf="selectionMode === 'facture' && row.kind === 'consolide_blocked'" class="text-danger small">Ticket déjà consolidé</div>
            <div *ngIf="selectionMode === 'facture' && row.kind === 'cloture_blocked'" class="text-danger small">Ticket de clôture — non facturable</div>
            <div *ngIf="selectionMode === 'facture' && row.kind === 'particulier_blocked'" class="text-danger small">Client particulier — incompatible avec facture entreprise</div>

          </td>

          <td>{{ formatDate(row.date) }}</td>

          <td>{{ row.entrepot }}</td>

          <td>{{ formatStatutLabel(row.statut, row.reglement) }}</td>

          <td *ngIf="selectionMode === 'facture'">{{ row.clientName }}</td>

          <td class="text-end" [class.text-danger]="row.total < 0">
            {{ row.total | number:'1.3-3' }}
            <div *ngIf="selectionMode === 'facture' && isAcompteSousType(row.sousType)" class="text-muted small">
              Acompte (hors total facture)
            </div>
          </td>

          <td class="text-center">

            <button

              type="button"

              class="btn btn-sm btn-link text-danger p-0"

              (click)="removeRow(row.id)"

              aria-label="Retirer de la sélection"

            >

              <i class="bi bi-trash" aria-hidden="true"></i>

            </button>

          </td>

        </tr>

      </tbody>

      <tfoot *ngIf="selectionMode === 'facture' && rows.length">
        <tr>
          <td colspan="5" class="text-end fw-semibold">Total facture (TTC)</td>
          <td class="text-end fw-semibold" [class.text-danger]="selectionFactureTotalTtc < 0">
            {{ selectionFactureTotalTtc | number:'1.3-3' }} DT
          </td>
          <td></td>
        </tr>
        <tr *ngIf="selectionTotalTtc !== selectionFactureTotalTtc" class="text-muted small">
          <td colspan="5" class="text-end">Somme tickets (TTC, acomptes inclus)</td>
          <td class="text-end">{{ selectionTotalTtc | number:'1.3-3' }} DT</td>
          <td></td>
        </tr>
      </tfoot>

    </table>

    <p *ngIf="filteredRows.length === 0" class="text-muted text-center py-3 mb-0">

      Aucun ticket ne correspond à la recherche « {{ searchTerm }} ».

    </p>

  </div>



  <p *ngIf="!isLoading && rows.length === 0 && !blockReason" class="text-muted text-center py-4 mb-0">

    Aucun ticket dans la sélection.

  </p>

</div>

